import { getLoginDataFromStorage } from '@shared/utils/loginUtils';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const Greeting = () => {
  const { t } = useTranslation();
  const { firstName } = getLoginDataFromStorage();
  const name = firstName;
  const dateOptions: Intl.DateTimeFormatOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  const today = new Date().toLocaleDateString('en-US', dateOptions);

  return (
    <div className="mb-6">
      <h1 className="text-2xl font-bold text-slate-800">{t("Good morning, {{name}}!", { name: name || t("User") })}</h1>
      <p className="text-sm text-slate-500 font-medium">{today}</p>
    </div>
  );
};
